export class BatchCertificationFlag {
  private _value: boolean

  public static isTrue (): BatchCertificationFlag {
    const self = new this(true)
    return self
  }

  public static isFalse (): BatchCertificationFlag {
    const self = new this(false)
    return self
  }

  private constructor (value: boolean) {
    this._value = value
  }

  value (): boolean {
    return this._value
  }
}
